import cloneDeep from 'clone-deep'
import { InputType } from 'config'
import { useEffect, useState } from 'react'
import { Modal } from 'stories/components'
import { InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

const defaultInputs = (): Record<string, InputType> => ({
  name: {
    inputType: 'text',
    title: 'Name',
    required: true,
    value: '',
  },
  subject: {
    inputType: 'text',
    title: 'Subject',
    required: true,
    value: 'Complete and sign your Loan Application - {loanNumber}',
    tooltip: 'Supports placeholders such as {loanNumber}, {{full_name}}, {{APPLICATION_LINK}}, {{COMPANY_TITLE}}, etc.',
  },
})

export const EditApplicationEmailTemplateModal = ({
  item,
  onClose,
  onSubmit,
}: {
  item: { id: number; name?: string; subject?: string } | null
  onClose: () => void
  onSubmit: (id: number, data: { name: string; subject: string }) => Promise<void>
}) => {
  const [inputs, setInputs] = useState<Record<string, InputType>>(defaultInputs())
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const next = defaultInputs()
    if (item) {
      next.name.value = item.name || ''
      next.subject.value = item.subject || next.subject.value
    }
    setInputs(next)
  }, [item])

  const onChange = (key: string, value: string) => {
    const next = cloneDeep(inputs)
    next[key].value = value
    next[key].error = InputValidate({ ...next[key], value })
    setInputs(next)
  }

  const handleSubmit = async () => {
    const next = cloneDeep(inputs)
    let hasError = false
    Object.keys(next).forEach((key) => {
      next[key].error = InputValidate(next[key])
      if (next[key].error) hasError = true
    })
    setInputs(next)
    if (hasError) return

    setLoading(true)
    try {
      await onSubmit(item?.id || 0, {
        name: String(next.name.value || ''),
        subject: String(next.subject.value || ''),
      })
      onClose()
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={`${item?.id ? 'Edit' : 'Add'} Template`}
      isOpen
      onClose={onClose}
      onOk={handleSubmit}
      loading={loading}
    >
      <div className="grid gap-4 w-[400px]">
        {Object.keys(inputs).map((key) => (
          <RenderInput key={key} input={inputs[key]} Key={key} onChange={onChange} />
        ))}
      </div>
    </Modal>
  )
}
